import { h } from 'preact';
import { useMemo, useState, useEffect } from 'preact/hooks';
import { useThreekit } from '../threekit-context';
import { formatMoney } from '../../utils/helpers';
import { useModal } from '../modal-context';
import ThreekitIcons from './threekit-icons';

function AddToCartButton({ className }) {
  const { openModal, modalName } = useModal();
  const {
    locales, getAllVariants, productTag, products, hasFlaggedContent,
  } = useThreekit();
  const [loading, setLoading] = useState(false);
  const allVariants = getAllVariants();
  const amount = allVariants.subtotal;
  const isServiceProduct = productTag === 'cstm:service';
  const addToCartText = useMemo(
    () =>
      (isServiceProduct
        ? 'ADD LASERMARKING'
        : locales?.general?.addToCart?.replace(
          '{{ price }}',
          formatMoney({ amount }),
        ) || 'Add to cart'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locales, amount],
  );

  useEffect(() => {
    if (modalName !== 'review-your-knife') {
      setLoading(false);
    }
  }, [modalName]);

  useEffect(() => {
    // run again if hasFlaggedContent changes
    if (hasFlaggedContent) {
      setLoading(false);
      openModal('');
    }
  }, [hasFlaggedContent]);

  // Check Availablity & Inventory
  const mainProduct = products.find((p) =>
    p.tags?.includes('Customizer:Main_Product'),
  );
  const mainProductAvailable = mainProduct.variants.edges[0].node.available;
  if (!mainProductAvailable) {
    return (
      <button disabled className={`btn-secondary disabled py-2 ${className}`}>
        {mainProductAvailable
          ? window.TMW.Strings.product.unavailable
          : window.TMW.Strings.product.outOfStock}
      </button>
    );
  }

  const handleButtonClick = () => {
    if (hasFlaggedContent) return;
    setLoading(true);
    openModal('review-your-knife');
  };

  return (
    <button
      className={`btn-secondary py-2 ${className}`}
      type="button"
      aria-label={addToCartText}
      onClick={handleButtonClick}
      disabled={loading || hasFlaggedContent}
    >
      {loading ? (
        <ThreekitIcons
          type="loading"
          className="w-[22px] h-[22px] m-auto animate-spin"
        />
      ) : (
        addToCartText
      )}
    </button>
  );
}

export default AddToCartButton;
